import React from "react"
import moment from "moment-timezone"

export default ({ value, shortMonthName = true, timeZone }) => {
  try {
    const monthFormat = shortMonthName ? "MMM" : "MMMM"
    const date = timeZone ? moment.tz(value, timeZone) : moment(value)
    const format = date.year() === moment().year() ? `${monthFormat} D` : `D ${monthFormat} YY`

    return (
      <span className="format-date" title={moment(date).local().format()}>
        {value && date.format(format)}
      </span>
    )
  } catch (ex) {
    return <span>Data invalid.</span>
  }
}
